// TValue=number, TName=string
import { TooltipProps } from "recharts";
import { Box, Flex, Grid, Text } from "@chakra-ui/react";
import { Fragment } from "react";

const MyDashboardCustomTooltip: React.FC<TooltipProps<number, string>> = ({
  active,
  payload,
  label,
}) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <Flex
      flexDirection={"column"}
      gap={"8px"}
      background={"#363636"}
      paddingX={"12px"}
      paddingY={"8px"}
      borderRadius={"8px"}
    >
      <Text textStyle={"body-sm-bold"} color={"#FFFFFF"}>
        {label}
      </Text>
      <Box>
        <Grid
          margin={0}
          padding={0}
          gridTemplateColumns={"max-content 80px"}
          gap={"6px 8px"}
        >
          <Text textStyle={"body-sm-medium"} color={"#FFFFFF"}>
            총 전시 상품
          </Text>
          <Text
            textStyle={"body-sm-bold"}
            color={"#FFFFFF"}
            justifySelf={"end"}
          >
            {payload.at(0)?.payload.total_count}개
          </Text>
          {[...payload].reverse().map((entry) => {
            return (
              <Fragment key={entry.dataKey}>
                <Flex gap={"8px"} alignItems={"center"}>
                  <span
                    style={{
                      display: "inline-block",
                      width: 8,
                      height: 8,
                      backgroundColor: entry.color, // dot 컬러
                      borderRadius: "50%",
                      marginRight: 6,
                    }}
                  />
                  <Text textStyle={"body-sm-medium"} color={"#FFFFFF"}>
                    {entry.name}
                  </Text>
                </Flex>
                <Text
                  textStyle={"body-sm-medium"}
                  color={"#FFFFFF"}
                  justifySelf={"end"}
                >
                  {entry.value}개
                </Text>
              </Fragment>
            );
          })}
        </Grid>
      </Box>
    </Flex>
  );
};

export default MyDashboardCustomTooltip;
